$(document).ready(function () {

    $('.fs-tabs .nav-tabs a.nav-link').each(function () {
        var $tab_anchor = $(this).data('tab-anchor');
        // console.log($tab_anchor)
        if ($tab_anchor != '') {
            $(this).attr('href', $(this).data('tab-anchor'));
        }
    })

    // CENTER TABS ON MOBILE =============
    $('.tabs-nav-wrapper a.nav-link').on('click', function (e) {
        // console.log(window.outerWidth + ', ' + window.innerWidth + ', ' + parseInt($breakpoints.md))
        if (window.innerWidth <= parseInt($breakpoints.md)) {
            e.preventDefault();
            // $(document).off("scroll");
            var $tab_nav = $(this).parents('.nav');
            var myScrollPos = $(this).offset().left + $(this).outerWidth() / 2 + $tab_nav.scrollLeft() - $tab_nav.width() / 2;
            $tab_nav.animate({scrollLeft: myScrollPos}, 800);
        }
    });

});